import { useSidebar } from '@heidi/design-system/page-shell';
import { useIsMobile } from '@heidi/utils';

/**
 * Single predicate for "the footer renders as one shared `<ul>`" — the desktop
 * icon rail. The parent (`SideNavFooter`) and every footer item read this same
 * hook so their wrap-vs-bare-`<li>` decisions can't drift: split across
 * different checks, if `label-icons` ever became mobile-reachable the parent
 * would stop wrapping while children still emit bare `<li>`, orphaning list
 * items. `isMobile` resolves from the same `useIsMobile()` the sidebar tree
 * already uses, so this matches the value passed down as a prop.
 */
export function useIsRibbonRail(): boolean {
  const { collapsible } = useSidebar();
  const isMobile = useIsMobile();
  return collapsible === 'label-icons' && !isMobile;
}
